<div #yourInfoWrapper>
  <div class="option-wrapper">
    <div class="variant-wrapper my-2 my-md-0">
      <!-- FORM -->
      <div
        class="expandable-content-wrapper">
        <form class="mx-3" [formGroup]="personalInfoForm">
          <div class="row" *ngIf="!nameFieldHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text 
                  class="mb-4"
                  inputId="name"
                  autocomplete="name"
                  maxLength="200"
                  [label]="'public.checkout.yourName' | translate"
                  [required]="!nameFieldOptional()"
                  [control]="getControl('name')"
                  [isInvalid]="checkoutService.isInvalid(getControl('name'))"
                  [errorText]="
                    getControl('name')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : 
                    getControl('name')?.errors?.whitespace || getControl('name')?.errors?.containsUrl ? ('public.payment.errors.valueNotValid' | translate) : ''
                  "
                  (keyupEvent)="checkFormValidity()"
                  (changeEvent)="addOrderMeta('customerName', 'name', 'personalInfoForm')"
                  appPreventEnter
                  />
              </div>
            </div>
          </div>
          <!-- Email -->
          <div class="row" *ngIf="!emailFieldHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text 
                  class="mb-4"
                  inputId="email"
                  autocomplete="email"
                  maxLength="200"
                  [label]="'public.checkout.email' | translate"
                  [required]="!emailFieldOptional()"
                  [control]="getControl('email')"
                  [isDisabled]="customerAuthService.isUserLoggedIn()"
                  [isInvalid]="(checkoutService.isInvalid(getControl('email')) || getControl('email').errors?.email)"
                  [errorText]="
                    getControl('email')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : 
                    (
                      getControl('email')?.errors?.email || 
                      getControl('email')?.errors?.whitespace || 
                      getControl('email')?.errors?.minlength || 
                      getControl('email')?.errors?.maxlength
                    ) ? ('public.payment.errors.valueNotValid' | translate) : ''
                  "
                  (keyupEvent)="checkFormValidity()"
                  (changeEvent)="addOrderMeta('customerEmail', 'email', 'personalInfoForm')"
                  appPreventEnter
                  />
              </div>
            </div>
          </div>
          <!-- Phone Number -->
          <div class="row" *ngIf="!phoneFieldHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-phone-input
                  [id]="'phone'"
                  [countryCode]="countryCode()"
                  [formControl]="getControl('phone')"
                  [invalidSubmit]="checkoutService.invalidSubmit()"
                  [required]="!phoneFieldOptional()"
                  (inputChange)="checkFormValidity(); addOrderMeta('customerPhoneNumber', 'phone', 'personalInfoForm');"
                  (change)="checkFormValidity(); addOrderMeta('customerPhoneNumber', 'phone', 'personalInfoForm');"
                  [countryName]="getCountryNameCode()"
                  >
                </app-phone-input>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- FORM END -->
    </div>
  </div>
</div>
